<template>
  <div class="colle">
    <div>
      <div class="swiper-container swiper-container2">
        <div class="swiper-wrapper">
          <div v-for="col of colleList" :key="col.id" style class="swiper-slide">
            <div>
              <img :src="col.imgUrl" class="img"/>
              <div>
                <p class="colleP">{{ col.title }}</p>
                <p class="colleNei">{{ col.neirong }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-next swiper-button-black"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      slideNum:null,
      colleList: [
        {
          id: 0,
          imgUrl: "https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/colle/1.jpg",
          title: "鲜藕",
          neirong:
              "洪湖莲藕可以清炒、油炸、凉拌、清蒸、煲汤等，吃法多达数百种。在所有吃法中，最有名、最美味的是“洪湖藕汤”，在洪湖，素有“三天不喝藕汤，做事心里发慌”的说法。据说，要煲一锅好的藕汤，选藕一定要挑选正宗的青泥巴洪湖莲藕，搭配生姜、葱段、食盐以及排骨，在砂锅中用小火慢炖，越炖越香、香飘四溢。"
        },
        {
          id: 1,
          imgUrl: "https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/colle/2.jpg",
          title: "鲜莲",
          neirong: '莲子可以用来煮粥、煲汤、做甜品，每一种做法都能让白莲子的美味充分释放。煮成莲子粥，口感软糯，香气扑鼻;煲成莲子汤，营养丰富;制成莲子甜品，甜蜜可口，令人陶醉。'
        },
        {
          id: 2,
          imgUrl: "https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/colle/3.jpg",
          title: "藕带",
          neirong: '藕带无论是凉拌、清炒还是炖汤，都能展现出其独特的口感魅力。其纤维细腻，入口爽滑，略带一丝天然的甘甜，既无一般野菜的苦涩，也不似某些蔬菜的生硬，呈现出一种恰到好处的清爽与醇厚‌'
        },
        {
          id: 3,
          imgUrl: "https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/colle/4.jpg",
          title: "藕粉",
          neirong: '藕粉不仅可以直接冲泡食用，还可以作为烹饪原料，用于制作各种糕点、甜品等。'
        },
        {
          id: 4,
          imgUrl: "https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/colle/5.jpg",
          title: "莲子",
          neirong: '‌白莲子可用于多种健康问题的治疗和改善。‌ 白莲子具有补脾止泻、益肾涩精、养心安神、止带等功效，主要用于治疗脾虚泄泻、肾气不足、精关不固所致遗精、带下等病症‌。'
        }
      ]
    };
  },
  methods: {
    slideS(){
      let innerWidth = window.innerWidth
      if(innerWidth < 600){
        this.slideNum = 2
      } else {
        this.slideNum = 4
      }
    }
  },
  mounted() {
    this.slideS()
    new Swiper(".swiper-container2", {
      loop: true,
      slidesPerView: this.slideNum,
      // autoplay: {
      //   delay: 1500,
      //   stopOnLastSlide: false,
      //   disableOnInteraction: false,
      //   pauseOnMouseEnter: true
      // },
      // 前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      autoplay: {
        // 每次切换的毫秒数
        delay: 2000,
        //如果设置为true，当切换到最后一个slide时停止自动切换
        // stopOnLastSlide: true,
        //用户操作swiper之后，是否禁止autoplay
        disableOnInteraction: false
      }
    });
  }
};
</script>

<style lang="less" scoped>
.colle {
  padding: 20px;
}

.colleP {
  width: 90%;
  margin: 20px 30px 0 0;
  font-size: 1.2vw;
  font-weight: 600;
  text-align: center;
}

.colleNei {
  padding-left: 10px;
  width: 80%;
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.8vw;
}

.img {
  width: 90%;
  height: 300px;
  margin: 0 auto
}

@media screen and (max-width: 599px) {
  .colleP {
    font-size: 12px;
  }

  .colleNei {
    font-size: 9px;
  }

  .img {
    width: 150px;
    height: 150px;
    margin: 0 auto
  }

  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    font-size: 20px;
    margin-bottom: 70px;
    margin-left: 35px;
  }

}
</style>